<template>
  <div class="icon" :class="sizeClass" :style="rotation">
    <component :class="sizeClass" :is="iconFile" :color="colorComputed" aria-labelledby="desc">
      <desc>{{ altFinal }}</desc>
    </component>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { useTheme } from "@/utils/index";

export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 18,
    },
    color: {
      type: String,
      default: "default",
    },
    alt: String,
    rotate: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const iconList = {
      access: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Access"),
      add: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Add"),
      "address-tax": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/AddressTax"
        ),
      "angle-left": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/AngleLeft"
        ),
      announcements: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Announcements"
        ),
      "api-tokens": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ApiTokens"
        ),
      architecture: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Architecture"
        ),
      backup: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Backup"),
      billing: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Billing"),
      call: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Call"),
      chat: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Chat"),
      checkmark: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Checkmark"
        ),
      clipboard: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Clipboard"
        ),
      close: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Close"),
      "cloud-account": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/CloudAccount"
        ),
      "cloud-servers": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/CloudServers"
        ),
      colo: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Colo"),
      containers: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Containers"
        ),
      "control-panel": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ControlPanel"
        ),
      "credit-cards": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/CreditCards"
        ),
      credits: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Credits"),
      db: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Db"),
      dedicated: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Dedicated"
        ),
      dns: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Dns"),
      "dns-zones": () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/DnsZones"),
      domain: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Domain"),
      "domain-options": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/DomainOptions"
        ),
      down: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Down"),
      download: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Download"),
      edit: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Edit"),
      email: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Email"),
      environment: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Environment"
        ),
      environments: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Environments"
        ),
      error: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Error"),
      hamburger: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Hamburger"
        ),
      help: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Help"),
      hide: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Hide"),
      home: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Home"),
      info: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Info"),
      invoices: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Invoices"),
      links: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Links"),
      loader: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Loader"),
      lock: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Lock"),
      logs: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Logs"),
      "magento-patches": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/MagentoPatches"
        ),
      "malware-scans": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/MalwareScans"
        ),
      "open-page": () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/OpenPage"),
      orders: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Orders"),
      other: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Other"),
      partner: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Partner"),
      payments: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Payments"),
      performance: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Performance"
        ),
      permissions: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Stamp"),

      "rdns-records": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/RdnsRecords"
        ),
      "refer-a-friend": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ReferAFriend"
        ),
      referrals: () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Referrals"
        ),
      "reseller-hosting": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ResellerHosting"
        ),
      "safe-harbor": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/SafeHarbor"
        ),
      settings: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Settings"),
      shared: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Shared"),
      sites: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Sites"),
      "sort-arrow": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/SortArrow"
        ),
      "ssh-keys": () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/SshKeys"),
      ssl: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Ssl"),
      "staging-environments": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/StagingEnvironments"
        ),
      stamp: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Stamp"),
      stencils: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Stencils"),
      success: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Success"),
      support: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Support"),
      tasks: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Tasks"),
      "threat-protection": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ThreatProtection"
        ),
      "thumbs-down": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ThumbsDown"
        ),
      "thumbs-up": () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ThumbsUp"),
      team: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Team"),
      "three-dots": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/ThreeDots"
        ),
      trash: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Trash"),
      unlock: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Unlock"),
      view: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/View"),
      "visual-compare": () =>
        import(
          /* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/VisualCompare"
        ),
      warning: () =>
        import(/* webpackChunkName: "icons" */ "@/components/display/icon/svg-components/Warning"),
    };

    const { theme } = useTheme();

    const iconFile = computed(() => {
      return iconList[props.icon] || null;
    });

    const sizeClass = computed(() => {
      return `size-${props.size}`;
    });

    const altFinal = computed(() => {
      return props.alt || props.icon;
    });

    const rotation = computed(() => {
      return { transform: `rotate(${props.rotate}deg)` };
    });

    const colorComputed = computed(() => {
      return theme.value?.iconColors?.[props.color] || theme.value?.iconColors?.default;
    });

    return {
      iconFile,
      sizeClass,
      altFinal,
      colorComputed,
      rotation,
    };
  },
};
</script>

<style lang="scss" scoped>
.icon {
  position: relative;

  @for $i from 1 through 50 {
    &.size-#{$i} {
      width: #{$i}px;
      height: #{$i}px;
    }
  }

  svg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: transform 0.5s ease;
    @for $i from 1 through 50 {
      &.size-#{$i} {
        width: #{$i}px;
        height: #{$i}px;
      }
    }
  }
}
</style>
